// extracted by mini-css-extract-plugin
export default {"support":"Support_support__jLe6T","infoWrapper":"Support_infoWrapper__CxpLk"};